import React, { useState, useEffect, useCallback, useMemo } from "react";
import { ReactFlow, useNodesState, useEdgesState, addEdge, Handle, Position } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import './Flow.css';

const initialData = {
    userId: "123",
    subIds: [
        { userId: "14" },
        { userId: "16" },
        { userId: "17" },
        { userId: "1477" },
        {
            userId: "78",
            subIds: [
                {
                    userId: "42",
                    subIds: [{ userId: "44", subIds: [{ userId: "777" }] }, { userId: "447" }],
                },
            ],
        },
    ],
};

const generateNodesAndEdges = (data, user, percentage, parentId = null, x = 0, y = 0, level = 0, nodes = [], edges = []) => {
    const nodeId = data?.userId ? data.userId.slice(0, 8) : data?.userId;
    const leveler = x === 0 && y === 0 ? data?.userId ? data.userId.slice(0, 8) : data?.userId : `${nodeId}`;

    nodes.push({
        id: nodeId,
        position: { x, y },
        data: { label: leveler, badge: `${percentage}%` },
        type: x === 0 && y === 0 ? "input" : "custom",
        draggable: true,
        selectable: true,
        style: {
            backgroundColor: data?.isStake ? 'rgb(0, 255, 163)' : 'white',
            color: data?.isStake ? 'black' : 'black',
            fontWeight: 'bold',
            fontSize: '8px',
        }
    });

    if (parentId) {
        edges.push({
            id: `e${parentId}-${nodeId}`,
            source: parentId,
            target: nodeId,
            type: 'smoothstep',
            animated: true,
            style: { stroke: '#00FFA3', strokeWidth: 2 },
        });
    }

    if (data.subIds && data.subIds.length) {
        const totalChildren = data.subIds.length;
        const spacing = 200;
        const childXStart = x - ((totalChildren - 1) * spacing) / 2;

        data.subIds.forEach((child, index) => {
            const childX = childXStart + index * spacing;
            generateNodesAndEdges(child, user, 10, nodeId, childX, y + 120, level + 1, nodes, edges);
        });

        if (!parentId) {
            nodes.find(n => n.id === nodeId).position.x = x;
        }
    }

    return { nodes, edges };
};

const CustomNode = ({ data }) => {
    return (
        <>
            <Handle type="target" position={Position.Top} />
            <div style={{ position: 'relative', textAlign: 'center', minWidth: '40px', minHeight: '45px' }}>
                {/* {data?.badge && (
                    <div style={{
                        position: 'absolute',
                        top: '-50%',
                        right: '15%',
                        display: 'inline-flex',
                        background: '#FFE3E2',
                        padding: '5px 6px',
                        borderRadius: '25px',
                        fontSize: '10px',
                        color: '#F10D0D',
                        fontFamily: '"Poppins", sans-serif',
                        fontWeight: 700,
                    }}>
                        {data?.badge}
                    </div>
                )} */}
                <div style={{ position: 'relative', top: '15px' }}>
                    {data?.label}
                </div>
            </div>
            <Handle type="source" position={Position.Bottom} />
        </>
    );
};

const FlowChartHome = ({ getReferralStake, user }) => {
    const [treeData] = useState(getReferralStake || initialData);
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const [flowHeight, setFlowHeight] = useState('400px');

    useEffect(() => {
        const { nodes, edges } = generateNodesAndEdges(treeData, user, 0);
        setNodes(nodes);
        setEdges(edges);
        const maxDepth = Math.max(...nodes.map(node => node.position.y)) || 0;
        const calculatedHeight = Math.max(500, maxDepth + 150);
        setFlowHeight(`${calculatedHeight}px`);
        setTimeout(() => {
            setFlowHeight(() => '80vh')
        }, 2000);
    }, [treeData, setNodes, setEdges]);

    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);

    const nodeTypes = useMemo(() => ({ custom: CustomNode }), []);

    return (
        <div style={{ height: flowHeight, width: '100%', overflow: 'auto' }}>
            <ReactFlow
                nodeTypes={nodeTypes}
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                fitView
                elementsSelectable
                nodesDraggable
                nodesConnectable
                style={{ height: '100%', width: '100%', fontWeight: 'bold' }}
            />
        </div>
    );
};

export default FlowChartHome;
